import { defineColumns } from '@juvare/platform-shared/features/storage';
export const groupsWithCustomFieldsViewName = 'groupsWithCustomFieldsView';
export const groupsWithCustomFieldsColumns = defineColumns({
    id: { type: 'id-required' },
    groupName: { type: 'string-required' },
    groupOwner: { type: 'string-required' },
    groupFilters: { type: 'string-array-required' },
});
